import React from "react";

export default function ChildrenButton({ number, onClick, isSelected }) {
    let text;

    if (number === 1) {
        text = "simple";
    } else if (number === 2) {
        text = "jumeaux";
    } else if (number > 2) {
        text = "triplés ou plus";
    }

    const selectedClasses = isSelected
        ? "bg-slate-700 hover:bg-slate-600 text-white shadow-md"
        : "bg-stone-100 hover:bg-stone-50 text-gray-900";

    return (
        <button className={`w-1/3 p-4 rounded-lg flex flex-col active:text-white focus:ring focus:ring-slate-300 hover:cursor-pointer shadow-xl ${selectedClasses}`}
            onClick={() => onClick(number)}
            aria-label={text}
        >
            <div className="flex items-center self-center">
                <div className="flex items-center gap-1 w-full">
                    {Array.from({ length: number }, (_, index) => (
                        <svg key={index} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
                            <path d="M14 16C13.4271 16.6318 12.7395 17 12 17C11.2605 17 10.5729 16.6318 10 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                            <path d="M9 11.5C8.71357 11.1841 8.36974 11 8 11C7.63026 11 7.28643 11.1841 7 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                            <path d="M17 11.5C16.7136 11.1841 16.3697 11 16 11C15.6303 11 15.2864 11.1841 15 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                            <path d="M12 2C10.3431 2 9 3.34315 9 5C9 6.65685 10.3431 8 12 8C12.7684 8 13.4692 7.71115 14 7.23611" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                    ))}
                </div>
            </div>
            <span className="self-center mt-1 font-semibold text-xs sm:text-sm text-center">{text}</span>
        </button>
    );
}
